import { combineReducers } from '@reduxjs/toolkit'
import appInstance from './appSlice'
// import appProvider from './currentProviderSlice'

const reducer = combineReducers({
    appInstance,
})

export default reducer
